<template>
    <h1>Hola desde correos</h1>
</template>

<script>
export default {
}
</script>

<style lang="css" scoped>
</style>
